import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { SessionStorageService } from '@core/services/session-storage.service';
import { SessionTimeoutService } from '../services/session-timeout.service';

/**
 * ✅ Guard to check session ID and redirect to eclaim-top if missing
 */
export const sessionGuard: CanActivateFn = (route, state) => {
  const sessionStorage = inject(SessionStorageService);
  const router = inject(Router);
  const sessionTimeout = inject(SessionTimeoutService);

  const sessionId = sessionStorage.getSessionId();

  if (!sessionId) {
    console.warn('🚫 No session ID, redirecting to eclaim-top');
    return router.createUrlTree(['/eclaim']);
  }

  // ✅ Check if session is still valid
  if (!sessionTimeout.isSessionValid()) {
    console.warn('⚠️ Session expired, clearing and redirecting');
    sessionStorage.clearAppData();
    sessionTimeout.stop();
    return router.createUrlTree(['/eclaim']);
  }

  // ✅ Start session timeout if not already started
  if (!sessionTimeout.isActive()) {
    sessionTimeout.start();
  }

  return true;
};